import { useRef } from "react";

declare global {
  interface Window {
    __vconsoleInstance__?: {
      show?: () => void;
      hide?: () => void;
      showSwitch?: () => void;
      hideSwitch?: () => void;
      setOption?: (key: string, value: unknown) => void;
    } | null;
  }
}

const LONG_PRESS_DURATION_MS = 1500;

const isMobileDevice = (): boolean =>
  /iPhone|iPad|iPod|Android/i.test(globalThis.navigator?.userAgent ?? "");

export const showVConsole = async (): Promise<void> => {
  if (globalThis.window.__vconsoleInstance__) {
    globalThis.window.__vconsoleInstance__.show?.();
    return;
  }

  const { default: VConsole } = await import("vconsole");
  const instance = new VConsole();
  instance.setOption?.("maxLogNumber", 1000);
  globalThis.window.__vconsoleInstance__ = instance;
  instance.show?.();
};

export const useLongPressVConsole = () => {
  const pressTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const clearPressTimer = () => {
    if (pressTimerRef.current) {
      clearTimeout(pressTimerRef.current);
      pressTimerRef.current = null;
    }
  };

  const handlePressStart = () => {
    if (!isMobileDevice()) return;

    clearPressTimer();
    pressTimerRef.current = setTimeout(() => {
      showVConsole();
      pressTimerRef.current = null;
    }, LONG_PRESS_DURATION_MS);
  };

  return {
    onTouchStart: handlePressStart,
    onTouchEnd: clearPressTimer,
    onTouchCancel: clearPressTimer,
    onMouseDown: handlePressStart,
    onMouseUp: clearPressTimer,
    onMouseLeave: clearPressTimer,
  };
};
